var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#94BE43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8004 11.3308H16.2004C14.3781 11.3308 12.9004 12.8086 12.9004 14.6308V33.3691C12.9004 35.1914 14.3781 36.6691 16.2004 36.6691H31.8004C33.6227 36.6691 35.1004 35.1914 35.1004 33.3691V14.6308C35.1004 12.8086 33.6227 11.3308 31.8004 11.3308ZM33.3004 33.3691C33.3004 33.7664 33.1422 34.1484 32.861 34.4297C32.5797 34.7109 32.1977 34.8691 31.8004 34.8691H16.2004C15.3719 34.8691 14.7004 34.1976 14.7004 33.3691V14.6308C14.7004 13.8023 15.3719 13.1308 16.2004 13.1308H31.8004C32.1977 13.1308 32.5797 13.289 32.861 13.5703C33.1422 13.8515 33.3004 14.2335 33.3004 14.6308V33.3691Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 23.25H17.2203C16.7235 23.25 16.3203 23.6531 16.3203 24.15C16.3203 24.6469 16.7235 25.05 17.2203 25.05H18.7062C19.2031 25.05 19.6062 24.6469 19.6062 24.15C19.6062 23.6531 19.2031 23.25 18.7062 23.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7805 23.25H21.9869C21.4901 23.25 21.0869 23.6531 21.0869 24.15C21.0869 24.6469 21.4901 25.05 21.9869 25.05H30.7805C31.2774 25.05 31.6805 24.6469 31.6805 24.15C31.6805 23.6531 31.2774 23.25 30.7805 23.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 17.85H17.2203C16.7235 17.85 16.3203 18.2531 16.3203 18.75C16.3203 19.2468 16.7235 19.65 17.2203 19.65H18.7062C19.2031 19.65 19.6062 19.2468 19.6062 18.75C19.6062 18.2531 19.2031 17.85 18.7062 17.85Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7805 17.85H21.9869C21.4901 17.85 21.0869 18.2531 21.0869 18.75C21.0869 19.2468 21.4901 19.65 21.9869 19.65H30.7805C31.2774 19.65 31.6805 19.2468 31.6805 18.75C31.6805 18.2531 31.2774 17.85 30.7805 17.85Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 28.6499H17.2203C16.7235 28.6499 16.3203 29.053 16.3203 29.5499C16.3203 30.0468 16.7235 30.4499 17.2203 30.4499H18.7062C19.2031 30.4499 19.6062 30.0468 19.6062 29.5499C19.6062 29.053 19.2031 28.6499 18.7062 28.6499Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7805 28.6499H21.9869C21.4901 28.6499 21.0869 29.053 21.0869 29.5499C21.0869 30.0468 21.4901 30.4499 21.9869 30.4499H30.7805C31.2774 30.4499 31.6805 30.0468 31.6805 29.5499C31.6805 29.053 31.2774 28.6499 30.7805 28.6499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f690908d21197fbc6e020df06ffd8218.svg";
export { ForwardRef as ReactComponent };